import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUserQuickInfo extends Layout {
    panelUser: Panel;
    sourceUsers: DataSource;
    textboxDepartmentId: Textbox;
    textboxEmailAddress: Label;
    textboxId: Textbox;
    textboxName: Textbox;
}
